import { useSelector } from 'react-redux'
import { Redirect } from 'react-router-dom'
import PrivateRoute from './PrivateRoute'

// a custom route for FeaturedLab
const FeaturedLabRoute = ({ ...rest }) => {
  const { hasFeaturedLab, loaded } = useSelector(state => ({
    hasFeaturedLab: state.ui.sidebar.hasFeaturedLab,
    loaded: state.ui.sidebar.loaded,
  }))
  const allowedRoles = ['teacher', 'district-admin', 'superadmin', 'student']

  // Wait for sidebar data to load before redirecting
  if (!loaded) {
    return null // or a loading spinner
  }

  if (!hasFeaturedLab) {
    return <Redirect to="/" />
  }

  return (
    <PrivateRoute
      allowedRoles={allowedRoles}
      {...rest}
    />
  )
}

export default FeaturedLabRoute
